// extracted by mini-css-extract-plugin
export var label = "_ix-2";
export var slideContainer = "_ix-0";
export var slider = "_ix-1";